import { render, staticRenderFns } from "./idxMarquee.vue?vue&type=template&id=36cf3608&"
import script from "./idxMarquee.vue?vue&type=script&lang=js&"
export * from "./idxMarquee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports